// extracted by mini-css-extract-plugin
export default {"login":"ChangePassword_login__1wY2A","content":"ChangePassword_content__5cHOn","submit":"ChangePassword_submit__oq4oc"};